<template>
  <div class="page page-film">

    <template v-if="this.data?.sections">
      <component
        v-for="(section, i) in this.data?.sections"
        :key="i"
        :is="section.blocName"
        :content="section"
      ></component>
    </template>

    <Footer />
    <GridHelper />
  </div>
</template>

<script>
import GridHelper from '@/components/GridHelper.vue'
import PlayerControlls from '@/components/PlayerControlls.vue'
import Slider from '@/components/Slider.vue'
import Footer from '@/components/Footer.vue'

import TextImageLandscape from '@/components/TextImageLandscape.vue'
import TextMediaPortrait from '@/components/TextMediaPortrait.vue'
import TextMediaFull from '@/components/TextMediaFull.vue'
import MainText from '@/components/MainText.vue'
import PlayerFull from '@/components/PlayerFull.vue'
import TwoImages from '@/components/TwoImages.vue'
import ImagesColumns from '@/components/ImagesColumns.vue'
import MosaicColumns from '@/components/MosaicColumns.vue'
import ImageWide from '@/components/ImageWide.vue'

import i18n from '@/i18n/i18n'
import signals from '@/store/signals'

export default {
  name: 'Film',
  components: {
    PlayerFull,
    PlayerControlls,
    MainText,
    TwoImages,
    ImagesColumns,
    MosaicColumns,
    Slider,
    ImageWide,
    TextMediaFull,
    TextImageLandscape,
    TextMediaPortrait,
    Footer,
    GridHelper
  },
   beforeMount () {
     window.scrollTo(0, 0)
  },
  mounted () {
    signals.resetScrollama.dispatch()
  },
  data () {
    return {
      data: i18n.global.messages[i18n.global.locale].film,
    }
  },
  watch:{
    $route (to, from){
      this.data = i18n.global.messages[i18n.global.locale].film
    }
  } 
}
</script>

<style lang="scss">
 
</style>
